var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{directives:[{name:"intersect",rawName:"v-intersect.once",value:(_vm.handleView),expression:"handleView",modifiers:{"once":true}}],staticClass:"proposal-img",attrs:{"rounded":"md","href":_vm.link,"elevation":"2"},on:{"click":_vm.handleLink}},[_c('v-img',{attrs:{"src":_vm.src,"alt":_vm.proposal.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }